import { motion } from "framer-motion";
import { MISSION } from "./data";

const ease = [0.16, 1, 0.3, 1];
const MISSION_HIGHLIGHT = "school's journey towards excellence";
const [missionBefore, missionAfter] = MISSION.split(MISSION_HIGHLIGHT);

export const OtherServices = () => (
  <section id="mission" className="relative py-24 md:py-36" data-testid="mission">
    <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease }}
        className="text-sm md:text-base tracking-[0.22em] uppercase font-semibold text-terra mb-6"
      >
        The TPJ Mission
      </motion.p>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease, delay: 0.05 }}
        className="font-serif text-3xl md:text-5xl leading-[1.15] tracking-tight text-ink"
      >
        {missionBefore}
        <span className="text-terra">{MISSION_HIGHLIGHT}</span>
        {missionAfter}
      </motion.p>
    </div>
  </section>
);
